import {checkPassport} from '@router/guards/roleGuard'
export default {
  path: '/proposal',
  component: () => import('@views/Proposal/Index'),
  beforeEnter: checkPassport,
  children: [
    {
      path: 'index',
      name: 'proposal.index',
      component: () => import('@/components/Proposal/ProposalIndex'),
    },
    // {
    //   path: 'detail/:id',
    //   name: 'proposal.detail',
    //   component: () => import('@/components/Proposal/ProposalDetail'),
    // },
  ]
}